import { render, staticRenderFns } from "./contract_text_en.vue?vue&type=template&id=15d2ce07&scoped=true"
import script from "./contract_text_en.vue?vue&type=script&lang=js"
export * from "./contract_text_en.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d2ce07",
  null
  
)

export default component.exports